export const parserForm = (event: any) => {
  const fieldsList = [...event.target]
    .filter((elm) => elm.value && elm.name)
    .reduce((cash, elm) => ({ ...cash, [elm.name]: elm.value }), {});

  return fieldsList;
};
